<template>
    <div class="automation-scheduler" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div class="toolbar">
            <div class="title">{{$t("automation.configSchedulerAuto")}}</div>
            <div class="actions">
                <SupsisButton primary :disabled="!isChanged()" @click="save"> {{$t("automation.saveChanges")}}</SupsisButton>
                <SupsisButton ghost @click="$emit('close', 0)">
                    <i class="material-icons">close</i>
                    {{ $t("message.close") }}
                </SupsisButton>
            </div>
        </div>

        <RRuleGenerator v-model="rrule" :max-count="365" />
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import { BlockStyles } from "../../../BlockConfiguration";
import BlockIconPreview from "../common/BlockIconPreview";
import RRuleGenerator from "../../../../Integrations/Ticimax/detail/automation/RRuleGenerator.vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import { AUTOMATION_API } from "../../../../../../api/automation";

const log = log2("AutomationScheduler");
export default {
    name: "AutomationScheduler",
    components: { SupsisButton, RRuleGenerator, BlockIconPreview },
    props: ["automation"],
    data() {
        return {
            animationObject: { classes: "fadeInDown", delay: 0, duration: 300 },
            animationInfinite: {
                classes: "fadeIn",
                duration: 5000,
                iteration: "infinite",
            },
            rrule: this.automation.options?.timer?.rrule || "",
        };
    },
    methods: {
        isChanged() {
            return this.rrule !== this.automation.options?.timer?.rrule;
        },
        save() {
            AUTOMATION_API.updateAutomationSingleKey(this.automation._id, "options.timer.rrule", this.rrule).then(
                (automation) => {
                    this.$message.success("Automation scheduler plan updated successfully");
                    this.$emit("updateAutomation", automation);
                }
            );
        },
    },
    watch: {
        rrule(val, oldVal) {
            log("rrule changed", { val, oldVal });
        },
        automation: {
            handler(val) {
                this.rrule = val.options?.timer?.rrule || "";
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-scheduler {
    box-shadow: 0 4px 20px #00000040;
    background: #ffffff;
    padding: 25px;
    border-radius: 6px;
    height: calc(100vh - 100px);
    overflow: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .close-x {
        display: flex;
        flex-direction: row;
        justify-content: end;
    }

    .toolbar {
        display: flex;
        justify-content: space-between;

        .title {
            font-size: 15px;
            font-weight: 600;
            color: #333;
        }

        .actions {
            display: flex;
            gap: 5px;
        }
    }
}
</style>
